import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { Button, Modal, Tooltip } from 'antd';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import PinPage from '../../../components/PinPage/PinPage';

import { Images } from '../../../config/images';
import { createPinApi } from '../../../services/authApi/authApi';
import { getUserProfileApi } from '../../../services/authApi/userApi';
import { addCounter, addUserData } from '../../../store/reducer/accountSlice';
import { toastNotify } from '../../../utils/toastNotify';
import { applyStoredFirstTouchUtmParams } from '../../../utils/utmTracker';

const ConfirmPin = () => {
  const [pin, setPin] = useState(undefined);
  const [isModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const location = useLocation();
  const search = useLocation().search;
  const token = new URLSearchParams(search).get('token');
 
  useEffect(() => {
    if (token) {
      localStorage.setItem('access_token_temp', token);
      window.history.replaceState(null, window.location.pathname, window.location.pathname);
    } else if (!token && !localStorage.getItem('access_token_temp')) {
      navigate('/login', { replace: true });
    }
    
    // Only add utm_campaign and gclid/fbclid parameters from localStorage
    const updatedParams = new URLSearchParams(window.location.search);
    applyStoredFirstTouchUtmParams(updatedParams);

    // Update URL with parameters
    if (updatedParams.toString()) {
      const finalUrl = `${location.pathname}?${updatedParams.toString()}`;
      window.history.replaceState(null, '', finalUrl);
    }
  }, [token, location, navigate]);

  const getUserProfile = async () => {
    setLoading(true);
    try {
      const resData = await getUserProfileApi();
      if (!resData.isError) {
        const { data } = resData;
        dispatch(addUserData({ userData: data?.user, isPinEntered: true }));
        dispatch(addCounter(data?.counter));
        if (window.location.pathname.includes('reactive-account/confirmpin')) {
          navigate('/');
        }
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmPin = async () => {
    setLoading(true);
    const localStoragePin = localStorage.getItem('pin');
    const bodyData = {
      pin: localStoragePin,
    };
    const isMatchPin = localStoragePin === pin;
    !isMatchPin && (toastNotify('error', 'PIN does not match.') || setLoading(false));

    if (isMatchPin) {
      try {
        const resp = await createPinApi(bodyData);
        if (!resp.isError) {
          localStorage.removeItem('pin');
          if (localStorage.getItem('access_token_temp')) {
            localStorage.setItem('access_token', localStorage.getItem('access_token_temp'));
            localStorage.removeItem('access_token_temp');
          }
          dispatch(addUserData({ isPinEntered: true }));
          localStorage.setItem('restrictPage', false);
          const array = new Uint8Array(16);
          window.crypto.getRandomValues(array); 
          const randomValue = Array.from(array, (byte) => byte.toString(16).padStart(2, '0')).join('');
          if(process.env.REACT_APP_WEBFLOW_LOGIN=== 'production'){
          document.cookie = `user_login=${randomValue}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/; domain=.realbricks.com`;
          }
          getUserProfile();
          navigate('/sign-up/verification/');
          // !window.location.pathname.includes('reactive-account/confirmpin') ? setIsModalOpen(true) : getUserProfile();
        } else {
          setPin('');
          toastNotify('error', resp?.message);
        }
      } catch (error) {
        setPin('');
        const { response } = error;
        toastNotify('error', response.data.message);
      } finally {
        setLoading(false);
      }
    }
  };
  const getAndSetProfileData = () => {
    getUserProfile();
  };

  return (
    // <SignUpWrapper>
      <div className='auth auth--no-info-mobile'>
        <PinPage
          pin={pin}
          authInfoTitle={'Create a PIN to secure your account'}
          authInfoDescription={'Do not share your 4-digit PIN with anyone under any circumstances.'}
          authFormTitle={'Re-enter your PIN'}
          authFormDescription={'Enter the 4-digit PIN you previously entered to ensure it is a match.'}
          lockMessage={'All of your information is encrypted and secure.'}
          setPin={(value) => setPin(value)}
          loading={loading}
          buttonName={'Confirm'}
          handleSubmit={handleConfirmPin}
          backButton
          backButtonRedirection={'sign-up/createpin'}
        />
        <Modal open={isModalOpen} closable={false} title={false} footer={false} width={524} centered>
          <div className='account-modal'>
            <div className='modal__image'>
              <LazyLoadImage src={Images.accountCreated} alt='A man climbing a hill' />
            </div>
            <h4 className='modal__title'>Congratulations! You’ve created a Realbricks account.</h4>
            <p className='modal__details'>
              Before you can begin investing in properties, we need to set up your
              <Tooltip
                placement='bottomLeft'
                title={`A brokerage account holds your financial assets (cash and property shares) on your behalf. Realbricks does not charge any fee on these accounts, nor does it offer any annual percentage yield. They are subject to ordinary income tax rates and capital gains taxes.`}
              >
                <span className='underline'> brokerage account</span>
              </Tooltip>
              . Do this now to get started building your wealth or finish this later before buying shares.
            </p>
            <div className='modal__actions'>
              <Button type='primary' className='ant-btn-primary--alt' onClick={getAndSetProfileData}>
                <Link to='/sign-up/verification/'>Get ready to invest</Link>
              </Button>
              <Link to='/' className='fw-600' onClick={getAndSetProfileData}>
                View properties
              </Link>
            </div>
          </div>
        </Modal>
      </div>
    // </SignUpWrapper>
  );
};

export default ConfirmPin;
